import { z } from "zod"

/**
 * @deprecated Use ProviderCalendarId from @/entities/providerCalendar instead
 */
export type ProviderCalendarId = "BASE" | "HPHC"

/**
 * @deprecated Use ProviderCalendarId from @/entities/providerCalendar instead
 */
export const ProviderCalendarId = {
    BASE: "BASE",
    HPHC: "HPHC",
} as const satisfies Record<ProviderCalendarId, ProviderCalendarId>

/**
 * @deprecated Use z.string() now since it's generic type
 */
export const ProviderCalendarIdSchema = z.enum(ProviderCalendarId)
